import React, { useContext, useEffect, useState } from 'react'
import { SelectImageComp } from "../molecule/selectImageComp"
import { TitleDescription } from "./titleDescription"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { MagicButton, StandardButton } from "../atoms/buttons"
import { TitleAtom } from "../atoms/titleAtom"
import { icon } from "../functions/icons"
import { EditCourseModal, ImageSelectorModalCopy } from "./customModals"
import { Alert } from "./alert"
import { CourseSettingComp } from "./courseSettingsComp"
import { PageContext, UserContext } from "../App"

import { PublishActionComp } from './publishActionComp'

export default function PublishCourseComp({setScoreModalVisible, quizStructure, courseData, activeModal,selectImage, openSelector, description, loadCourse}) {
  return (
    <HorizontalLayout className="publish-course-comp">
        <SelectImageComp
            description={description}
            courseData={courseData}
            title={courseData.title}
            disabled={courseData.published === 1 ? true : false}
            url={courseData?.image_url}
            openSelector={openSelector}
        /> 
        <ImageSelectorModalCopy
          visible={activeModal}
          imageSelected={selectImage}
          dismiss={openSelector}
        />
        <PublishActionComp setScoreModalVisible={setScoreModalVisible} quizStructure={quizStructure} data={courseData} loadCourse={loadCourse}/>
    </HorizontalLayout>
   )
    {/* <HorizontalLayout>
       
        <Sideinfo 
            loading={loading}
            setScoreModalVisible={setScoreModalVisible}
            courseData={courseData}
            activeModal={activeModal}
            loadCurrentCourse={loadCurrentCourse}
            selectImage={selectImage}
            openSelector={openSelector}
            loadCurrentCourseStucture={loadCurrentCourseStucture}
            editCourseInfo={editCourseInfo}
            setEditCourseInfo={setEditCourseInfo}
            isPublished={isPublished}
            setDeactivateVisible={setDeactivateVisible}
            activeCourseSetting={activeCourseSetting}
            errorMessage={errorMessage}
            scoreData={scoreData}
            isDeactivated={isDeactivated}
            startCourse={startCourse}
            publishLesson={publishLesson}
            setActiveCourseSettings={setActiveCourseSettings}
        />
    </HorizontalLayout> */}
  
}





// function SlidingPanel({ visible, children }) {
//   const [render, setRender] = useState(visible);

//   useEffect(() => {
//     if (visible) {
//       setRender(true);
//     } else {
//       const timeout = setTimeout(() => setRender(false), 400); 
//       return () => clearTimeout(timeout);
//     }
//   }, [visible]);

//   if (!render) return null;

//   return (
//     <div className={visible ? "slide-in" : "fade-out"}>
//       {children}
//     </div>
//   );
// }
